/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsBasemoduleTesterViewProps } from '../../../modules/hosports-basemodule-tester/./hosports-basemodule-tester';
import BoardFinder from './../../../baseComponents/board-finder/./board-finder';


export default (props: IHosportsBasemoduleTesterViewProps) => {
  return (
    <BoardFinder type="surf" />
  )
};
